import { NewUserOnboardingSteps } from './types';

export const NewUserOnboardingStepsOrder = [
  NewUserOnboardingSteps.BEGIN_SETUP,
  NewUserOnboardingSteps.VIEW_SELECTION,
  NewUserOnboardingSteps.POP_SELECTION,
  NewUserOnboardingSteps.THEME_SELECTION,
];
